export var BaseURLLocation;
(function (BaseURLLocation) {
    BaseURLLocation["us"] = "/us";
    BaseURLLocation["in"] = "/in";
    BaseURLLocation["za"] = "/za";
})(BaseURLLocation || (BaseURLLocation = {}));
export var BaseURLLocationName;
(function (BaseURLLocationName) {
    BaseURLLocationName["Africa/Johannesburg"] = "/za";
    BaseURLLocationName["Asia/Calcutta"] = "/in";
})(BaseURLLocationName || (BaseURLLocationName = {}));
